(() => {
  // Product tiles
  // Dawn examples: '.card-wrapper' or '.product-grid .grid__item' or '.product-card__figure'
  const PRODUCT_HOVER_SELECTOR = '.card-wrapper, .product-grid .grid__item, .product-card__figure';

  const el = document.getElementById('cursor-logo');
  if (!el) return;

  // ===== Random color =====
  function randomColor() {
    /* 
    Fashion-safe palette (less “rainbow toy”)
    – Yellow #F3EA5D
    – Light Orange #F2A900
    – Orange #EA7600
    – Red #FF585D
    – Pink #F57EB6
    – Lilac #D7A9E3
    – Light Pink #F4C3CB
    – Light Blue #8BB8E8
    – Blue #5C88DA
    – Dark Blue #00AFD7
    – Green #009A44
    – Turquoise #00B2A9
    – Pistachio #8CE2D0
    */
    const colors = [
      '#F3EA5D',
      '#F2A900',
      '#EA7600',
      '#FF585D',
      '#F57EB6',
      '#D7A9E3',
      '#F4C3CB',
      '#8BB8E8',
      '#5C88DA',
      '#00AFD7',
      '#009A44',
      '#00B2A9',
      '#8CE2D0',
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  }


// ===== State =====
  let active = false, rafId = null;

  // Pivot (cursor)
  const pivot = { x: 0, y: 0 };
  let prevX = null, prevY = null;

  // Vel/acc
  let vx = 0, vy = 0, lastVx = 0, lastVy = 0;

  // Pendulum
  let theta = 0;   // rad (0 = down)
  let omega = 0;

  // ===== CRAZY SETTINGS =====
  const STRING_LEN = 72;        // huge hang length (originally 120)
  const PIVOT_OFFSET_X = 10;
  const PIVOT_OFFSET_Y = 10;

  const G = 4200;      // lower gravity => floatier swings (originally 1800)
  const DAMPING = 0.92; // swings for a long time => less float, faster response  (originally 0.985)
  const MAX_ANGLE = 1.55;        // ~89 degrees (wild)

  const ACCEL_DRIVE = 0.00003;   // VERY strong drive (main knob)
  const VEL_SMOOTH = 0.85;       // very responsive

  // Extra "kick" when you flick the mouse
  const KICK_THRESHOLD = 1600;   // acceleration threshold
  const KICK_STRENGTH = 0.9;     // how hard the kick is

  // Return a value clamped to [a,b]
  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

  function show(tile) {
    if (active) return;
    active = true;

    el.style.color = tile?.dataset?.logoColor || randomColor();
    el.style.opacity = '1';

    // Big initial kick so it’s never subtle
    theta = (Math.random() * 1.2 - 0.6);  // -0.6..0.6 rad
    omega = (Math.random() * 8 - 4);      // -4..4

    if (!rafId) tick(performance.now());
  }

  function hide() {
    active = false;
    el.style.opacity = '0';
  }

  function onMove(e) {
    pivot.x = e.clientX + PIVOT_OFFSET_X;
    pivot.y = e.clientY + PIVOT_OFFSET_Y;
    if (prevX === null) { prevX = pivot.x; prevY = pivot.y; }
  }

  let lastT = null;
  function tick(t) {
    rafId = requestAnimationFrame(tick);
    if (lastT == null) lastT = t;

    let dt = (t - lastT) / 1000;
    lastT = t;
    dt = clamp(dt, 0.001, 0.03);

    // raw velocity
    const rawVx = (pivot.x - prevX) / dt;
    const rawVy = (pivot.y - prevY) / dt;
    prevX = pivot.x; prevY = pivot.y;

    // smooth
    vx += (rawVx - vx) * VEL_SMOOTH;
    vy += (rawVy - vy) * VEL_SMOOTH;

    // acceleration
    const ax = (vx - lastVx) / dt;
    const ay = (vy - lastVy) / dt;
    lastVx = vx; lastVy = vy;

    // drive from horizontal acceleration
    let drive = clamp(-ax * ACCEL_DRIVE, -2.5, 2.5);

    // BIG extra kick on flicks
    const aMag = Math.hypot(ax, ay);
    if (aMag > KICK_THRESHOLD) {
      // kick direction based on horizontal accel sign
      omega += clamp(-Math.sign(ax || 1) * KICK_STRENGTH, -2, 2);
    }

    // pendulum
    const alpha = -(G / STRING_LEN) * Math.sin(theta) + drive;
    omega += alpha * dt;
    omega *= DAMPING;
    theta += omega * dt;
    theta = clamp(theta, -MAX_ANGLE, MAX_ANGLE);

    // bob position
    const x = pivot.x + Math.sin(theta) * STRING_LEN;
    const y = pivot.y + Math.cos(theta) * STRING_LEN;

    // rotate to align with string
    const rotDeg = theta * 180 / Math.PI;

    el.style.transform =
      `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%) rotate(${rotDeg}deg)`;

    // stop when hidden + settled
    if (!active && el.style.opacity === '0') {
      if (Math.abs(omega) < 0.02 && Math.abs(theta) < 0.02) {
        cancelAnimationFrame(rafId);
        rafId = null;
        lastT = null;
        prevX = prevY = null;
        el.style.transform = 'translate(-9999px,-9999px)';
      }
    }
  }

  document.addEventListener('pointermove', onMove, { passive: true });

  document.addEventListener('pointerover', (e) => {
    const tile = e.target.closest(PRODUCT_HOVER_SELECTOR);
    if (tile) show(tile);
  });

  document.addEventListener('pointerout', (e) => {
    const fromTile = e.target.closest(PRODUCT_HOVER_SELECTOR);
    const toTile = e.relatedTarget?.closest ? e.relatedTarget.closest(PRODUCT_HOVER_SELECTOR) : null;
    if (fromTile && !toTile) hide();
  });
})();
